// @spec POL-STR-021
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { PolicyReviewPage } from '@/features/policies/components/PolicyReviewPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/policies/$policyId/review')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.reviewPolicy'),
  }),
  component: PolicyReviewRoute,
});

/**
 * Policy review route - Full review interface for approvers.
 *
 * Displays:
 * - Full policy content with table of contents
 * - Metadata sidebar with owner, dates, compliance mappings
 * - Approval workflow progress
 * - Review comments section
 * - Action buttons for approve, request changes, reject
 */
function PolicyReviewRoute() {
  const { policyId } = Route.useParams();

  return <PolicyReviewPage policyId={policyId} />;
}
